// extracted by mini-css-extract-plugin
module.exports = {"ruleModalRoot":"index-ruleModalRoot-M0ax1","title":"index-title-2zDmF","close":"index-close-1DY3n","content":"index-content-3du01","contentBox":"index-contentBox-sWP6t"};